const { debounce } = window.BAO.Utils

class PdpOrderDeadline extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this._loading = true
    this.source = this.els.source
    this.mobileCloneTarget = this.externalEls.mobile.element

    this.loadHandler()
  }

  loadHandler () {
    this.cloneElements = this.cloneElements.bind(this)

    this.debouncedCheckIfAppLoaded = debounce(() => {
      if (this.querySelector('.trustblox-message')) {
        this._loading = false
        this.cloneElements()
        return
      }
      this.debouncedCheckIfAppLoaded()
    }, 500)
    this.debouncedCheckIfAppLoaded()
  }

  cloneElements () {
    this.mobileCloneTarget.appendChild(this.source.element.cloneNode(true))
  }
}

if (!customElements.get('pdp-order-deadline')) {
  customElements.define('pdp-order-deadline', PdpOrderDeadline)
}
